import CreditCardDrawerComponent from './creditCardDrawer'
import ContactDrawerComponent from './contactDrawer'
import AlertsDrawerComponent from './alertsDrawer'
import ProfileDrawerComponent from './profileDrawer'

export const CreditCardDrawer = CreditCardDrawerComponent;
export const ContactDrawer = ContactDrawerComponent;
export const AlertsDrawer = AlertsDrawerComponent;
export const ProfileDrawer = ProfileDrawerComponent;